import React from 'react';
import { NavLink } from 'react-router-dom';

const tabs = [
  { to: '/admin/site', label: 'Tableau de bord' },
  { to: '/admin/site/accueil/slider', label: 'Accueil · Slider' },
  { to: '/admin/site/accueil/sections', label: 'Accueil · Sections' },
  { to: '/admin/site/realisations', label: 'Réalisations' },
  { to: '/admin/site/realisations/categories', label: 'Réal. · Catégories' },
  { to: '/admin/site/tarifs', label: 'Tarifs' },
  { to: '/admin/site/tarifs/plans', label: 'Tarifs · Plans' },
  { to: '/admin/site/tarifs/options', label: 'Tarifs · Options' },
  { to: '/admin/site/tarifs/comparatif', label: 'Tarifs · Comparatif' },
  { to: '/admin/site/contact', label: 'Contact' },
  { to: '/admin/site/contact/reglages', label: 'Contact · Réglages' },
  { to: '/admin/site/contact/messages', label: 'Contact · Messages' },
  { to: '/admin/site/annonces', label: 'Promotions' },
  { to: '/admin/site/taglines', label: 'Annonces' },
  { to: '/admin/site/effets', label: 'Effets Visuels' },
  { to: '/admin/site/blog/articles', label: 'Blog · Articles' },
  { to: '/admin/site/blog/categories', label: 'Blog · Catégories' },
  { to: '/admin/site/equipe', label: 'Équipe' },
];

function SiteTabs() {
  const navRef = React.useRef(null);
  const SCROLL_KEY = 'siteTabsScrollLeft';

  React.useLayoutEffect(() => {
    const nav = navRef.current;
    if (!nav) return;
    let tries = 0;
    const restore = () => {
      try {
        const saved = Number(sessionStorage.getItem(SCROLL_KEY) || '0');
        if (!Number.isNaN(saved) && saved >= 0) nav.scrollLeft = saved;
      } catch { }
      if (tries++ < 2) requestAnimationFrame(restore);
    };
    restore();
  });

  React.useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;
    const computeTarget = (tabEl) => {
      const navWidth = nav.clientWidth;
      const tabWidth = tabEl?.clientWidth || 0;
      const targetLeft = (tabEl?.offsetLeft || 0) - Math.max(0, (navWidth - tabWidth) / 2);
      const maxScroll = Math.max(0, nav.scrollWidth - navWidth);
      return Math.max(0, Math.min(maxScroll, targetLeft));
    };
    const onScroll = () => { try { sessionStorage.setItem(SCROLL_KEY, String(nav.scrollLeft)); } catch { } };
    const onPointerDown = (e) => {
      const tab = e.target && (e.target.closest ? e.target.closest('.site-tab') : null);
      if (tab) {
        const desired = computeTarget(tab);
        try { sessionStorage.setItem(SCROLL_KEY, String(desired)); } catch { }
      }
    };
    const onClick = (e) => {
      const tab = e.target && (e.target.closest ? e.target.closest('.site-tab') : null);
      if (tab) {
        const desired = computeTarget(tab);
        try { sessionStorage.setItem(SCROLL_KEY, String(desired)); } catch { }
      } else {
        try { sessionStorage.setItem(SCROLL_KEY, String(nav.scrollLeft)); } catch { }
      }
    };
    nav.addEventListener('scroll', onScroll, { passive: true });
    nav.addEventListener('pointerdown', onPointerDown, true);
    nav.addEventListener('click', onClick, true);
    return () => {
      nav.removeEventListener('scroll', onScroll);
      nav.removeEventListener('pointerdown', onPointerDown, true);
      nav.removeEventListener('click', onClick, true);
    };
  }, []);

  return (
    <div className="site-tabs">
      <nav ref={navRef} className="site-tabs-nav" aria-label="Onglets site">
        {tabs.map(t => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) => 'site-tab' + (isActive ? ' active' : '')}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

export default SiteTabs;
